import Vue from 'vue';
import * as types from '../types/auth.types';

export default {
  namespaced: true,
  state: {
    isAuth: false,
    token: null,
    insert: false,
  },
  getters: {
    authenticate: state => state.isAuth,
    token: state => state.token,
  },
  mutations: {
    [types.AUTHENTICATE](state, payload) {
      state.isAuth = payload;
    },
    [types.TOKEN](state, payload) {
      state.token = payload;
    },
    [types.PUSH_TOKEN](state) {
      state.insert = true;
    },
    [types.LOGOUT](state) {
      state.isAuth = false;
      state.token = null;
      state.insert = false;
      // window.localStorage.clear();
    },
  },
  actions: {
    async authenticate({ state, commit, dispatch }) {
      const token = window.localStorage.getItem('access_token');
      if (token) {
        commit(types.AUTHENTICATE, true);
        commit(types.TOKEN, token);
        if (!state.insert) await dispatch('createAuthHeader', token);
        // Dispatch for add new Token
        await dispatch('user/userInfo', {}, { root: true });
      }
    },
    async createAuthHeader({ commit }, token) {
      commit(types.PUSH_TOKEN);
      await Vue.http.interceptors.push((request, next) => {
        request.headers.set('Authorization', `Bearer ${token}`);
        request.headers.set('Accept', 'application/json');
        next();
      });
    },
    async logout({ commit, dispatch }) {
      await dispatch('user/clearUser', {}, { root: true });
      await commit(types.LOGOUT);
      return true;
    },
  },
};
